﻿import Vue from "vue";
import common from "../../common";
import core from "../../core";
import context_ from "../context";
import MessagesManager_ from "../components/MessagesManager";
import config_ from "../config";
import Notifications_ from "./Notifications";
import Pooler_ from "../../core/Pooler";
import utilities_ from "../utilities";
import AjaxService_ from "../../services/AjaxService";
import Navigation2_ from "./Navigation2";
import MainMenuVue_ from "../vue/MainMenuVue";
import MainFooterVue_ from "../vue/MainFooterVue";
import DefaultEdit_ from "./DefaultEdit";

declare function require(module: string): unknown;
const context = require("../context") as typeof context_;
const config = require("../config") as typeof config_;
const utilities = require("../utilities") as typeof utilities_;
// const MessagesManager = require("../components/MessagesManager") as MessagesManager_;
// const Notifications = require("./Notifications") as Notifications_;
// const Pooler = require("../../core/Pooler") as Pooler_;
// const AjaxService = require("../../services/AjaxService") as AjaxService_;
// const Navigation2 = require("./Navigation2") as Navigation2_;
// const MainMenuVue = require("../vue/MainMenuVue") as MainMenuVue_;
// const MainFooterVue = require("../vue/MainFooterVue") as MainFooterVue_;

interface ISettings {
    currentCulture?: string;
    enablePooler?: boolean;
    enableNotifications?: boolean;
    poolerFrequencySec?: number;
    showLoaderTarget?: string;
    hideLoaderTarget?: string;
    mainMenuRootId?: string;
    mainMenuFormName?: string;
    mainFooterRootId?: string;
    mainFooterFormName?: string;
    mainMessagesManagerRootId?: string;
    mainNotificationsRootId?: string;
    mainNavigationOpenChildrenOnClick: boolean;
}

//const jsClasses = require("../../js/jsClasses") as any;
//const jsUtilities = require("../../js/jsUtilities") as any;

//IMPORTANT: PolyFill pour le support du String.prototype.normalize('...')
require("unorm") as any;

interface IMainNavigationItemResponseData {
    message: common.IMessage;
}

//Elements commun de toutes les pages
class Page implements common.IWebComponent {
    componentType = common.WebComponentTypes.page;

    private _screenIsLocked = false;
    private _enablePooler = false;
    private _enableNotifications = false;
    private _mainNavigation?: Navigation2_;
    private _mainLoader?: core.Loader;
    private _messagesManager?: MessagesManager_;
    private _notifications?: Notifications_;
    private _pooler = null as Pooler_ | null;
    private _refreshPopup = null as core.ConfirmationPopup | null;
    private _mainMenuVue = null as MainMenuVue_ | null;
    private _mainFooterVue = null as MainFooterVue_ | null;

    init(s: ISettings) {
        if (!s.showLoaderTarget)
            s.showLoaderTarget = '.mod-popup .mpop-button.accept';

        if (!s.hideLoaderTarget)
            s.hideLoaderTarget = '.mod-popup .mpop-button.cancel';

        if (s.enablePooler === true || s.enablePooler === false)
            this._enablePooler = s.enablePooler;

        if (s.enableNotifications === true || s.enableNotifications === false)
            this._enableNotifications = s.enableNotifications;

        const currentCulture = (x => {
            return (x//default=FR
                ? (common.Cultures as any)[x] || (function () { throw "La culture '" + x + "' n'est pas supportée."; })()
                : common.Cultures.fr) as common.Cultures;
        })((s.currentCulture || '').trim());

        // update current culture context
        context.culture.name = currentCulture;

        this.setupEnvironmentButtonDisplayer();
        this.setupMainMenu(s, currentCulture);
        this.setupMainNavigation(s);
        this.setupMainLoader(s);
        this.setupMainFooter(s, currentCulture);
        this.setupPooler(s);
        this.setupMessageManager(s);
        this.setupNotifications(s);

        if (this._enablePooler)
            setTimeout(() => {
                this._pooler?.start();
            }, 250);

        setTimeout(() => {
            this.getMessagesManager()?.displayQueuedMessages(true);

            // TEST_ONLY
            // setTimeout(() => {
            //     const source = "TestSource";
            //     const manager = context.messages.getManager();

            //     manager.displayMessage({
            //         title: config.messages.defaultTitles.info,
            //         contentHtml: 'Ceci est un <em>test</em> (1).',
            //         linkUrl: null,
            //         messageSource: source,
            //         messageType: common.MessageTypes.info,
            //         autoClose: true
            //     } as common.IMessage, true);

            //     manager.displayErrorAsMessage(new core.Error("Ce est un autre <strong>test</strong> (2).", 99), source, true);

            //     manager.displayMessage({
            //         title: config.messages.defaultTitles.info,
            //         contentHtml: 'Ceci est un <em>test</em> (3).',
            //         linkUrl: "https://google.ca",
            //         linkText: "Aller a Google",
            //         linkAsBlank: true,
            //         messageSource: source,
            //         messageType: common.MessageTypes.info,
            //         autoClose: false
            //     } as common.IMessage, false);

            //     manager.displayMessage({
            //         title: config.messages.defaultTitles.warning,
            //         contentHtml: 'Ceci est un <em>test</em> (4).',
            //         linkUrl: null,
            //         messageSource: source,
            //         messageType: common.MessageTypes.error,
            //         autoClose: true
            //     } as common.IMessage, true);

            // }, 500);

        }, config.messages.initialDelayMsBeforeDisplayQueuedMessages);

        return context.components.add(this);
    }

    showRefreshPopup(action?: () => void, titleHtml?: string, messageHtml?: string) {
        if (!this._refreshPopup)
            this.setupRefreshPopup();

        action = action || (() => {
            utilities.refresh();
        });

        this._refreshPopup?.show(titleHtml || null, messageHtml || null, action);
        return this;
    }
    private setupRefreshPopup() {
        this._refreshPopup = new core.ConfirmationPopup("#MainRefreshPopup");
    }
    private setupMainMenu(s: ISettings, culture: common.Cultures) {
        if (!s.mainMenuRootId)
            return;

        Vue.prototype.$initialData = {
            vueElId: s.mainMenuRootId,
            formName: s.mainMenuFormName,
            currentCulture: culture
            // bag: s.bag || null,
            // loadFormModeFromUrl: s.loadFormModeFromUrl !== false,
            // embeddedContentModels: s.embeddedContentModels || null,
            // includesConcurrencySumCheck: true,
            // concurrencySumCheck: s.concurrencySumCheck || null
        };

        this._mainMenuVue = new MainMenuVue_().setOnCultureChangeCallback((culture: common.Cultures) => {
            this.changeCulture(culture);
        });

        // this._mainTopMenuVue.shared.setActionCallback((a: HotEditableFormAction_) => {
        //     this.onFormAction(a);
        // }).setErrorCallback(errors => {
        //     this.onFormActionError(errors);
        // });

        // this._mainTopMenuVue.shared.setupForm(this._isEditionAlwaysOn);

    }
    private setupMainFooter(s: ISettings, culture: common.Cultures) {
        if (!s.mainFooterRootId)
            return;

        Vue.prototype.$initialData = {
            vueElId: s.mainFooterRootId,
            formName: s.mainFooterFormName,
            currentCulture: culture
            // bag: s.bag || null,
            // loadFormModeFromUrl: s.loadFormModeFromUrl !== false,
            // embeddedContentModels: s.embeddedContentModels || null,
            // includesConcurrencySumCheck: true,
            // concurrencySumCheck: s.concurrencySumCheck || null
        };

        this._mainFooterVue = new MainFooterVue_();

        // this._mainTopMenuVue.shared.setActionCallback((a: HotEditableFormAction_) => {
        //     this.onFormAction(a);
        // }).setErrorCallback(errors => {
        //     this.onFormActionError(errors);
        // });

        // this._mainTopMenuVue.shared.setupForm(this._isEditionAlwaysOn);
    }
    private setupMainNavigation(s: ISettings) {

        this._mainNavigation = new Navigation2_().init({
            openChildrenOnClick: s.mainNavigationOpenChildrenOnClick === true
        }) as Navigation2_;

        this._mainNavigation.setOnItemClickAction((key: string) => {

            if (key === 'ImportImmediatMapaq') {

                const source = "MainNavigation";
                const service = new AjaxService_();

                service.post(context.webServices.mapaqChargementManuel, null, true, (data: IMainNavigationItemResponseData) => {
                    if (!data || !data.message) {
                        this.getMessagesManager()?.displayErrorAsMessage(new core.Error("Une erreur est survenue lors du chargement manuel du fichier MAPAQ."), source);
                        return;
                    }

                    this.getMessagesManager()?.displayMessage(data.message, true);
                }, (errors: any, config: any) => {
                    this.getMessagesManager()?.displayErrorAsMessage(errors[0], source);
                });
            }
        });
    }

    private setupPooler(s: ISettings) {
        if (this._enablePooler) {
            this._pooler = new Pooler_({
                frequencySec: s.poolerFrequencySec || null,
                poolingUrl: context.webServices.poolingApiUrl
            });
        }
    }

    private setupMessageManager(s: ISettings) {

        this._messagesManager = new MessagesManager_();
        this._messagesManager.init({
            rootId: s.mainMessagesManagerRootId,
            pooler: this._pooler
        });
    }

    private setupNotifications(s: ISettings) {

        if (!this._enableNotifications)
            return;

        this._notifications = new Notifications_();
        this._notifications.init({
            rootId: s.mainNotificationsRootId
        });
    }
    /** La apiFormatUrl doit contenir le placehoder suivant : {cultureName} */
    changeCulture(culture: common.Cultures, forceUpdate?: boolean) {
        if (!culture) throw "L'argument 'culture' est NULL.";
        // const apiUrl = context.webServices.apiCultureFormatUrl.replace('{cultureName}', culture).replace('{}');
        // const service = new AjaxService_();
        // service.post(apiUrl, null, false, (culture: common.Cultures) => {
        //     // if (!data || !data.message) {
        //     //     this.getMessagesManager().displayErrorAsMessage(new core.Error("..."), source);
        //     //     return;
        //     // }
        //     // this.getMessagesManager().displayMessage(data.message, true);
        //     //utilities.redirect(url); OR utilities.redirectWithOptions(url, data.redirectUrlOptions);
        //     context.culture.name = culture;
        //     this._mainTopMenuVue.updateCulture(culture);
        // }, errors => {
        //     //this.getMessagesManager().displayErrorAsMessage(errors[0], source);
        //     console.log(errors);
        // });
        if (context.culture.name !== culture || forceUpdate === true) {
            context.culture.name = culture;
            this._mainMenuVue?.refreshCultureFromContext();
            this._mainFooterVue?.refreshCultureFromContext().$nextTick(() => {
                this.refreshAllEmbeddedComponents();
            });
        }
    }
    showLanguageButton(value?: boolean) {
        this._mainMenuVue?.showCultureToggleButton(value);
        return this;
    }
    refreshAllEmbeddedComponents() {
        context.components.doForEarch((t: any, c: any) => {
            if (c.refreshEmbeddedComponents)
                c.refreshEmbeddedComponents();
        });
        return this;
    }
    screenIsLocked() {
        return this._screenIsLocked;
    }
    lockScreen(displayText?: boolean) {
        this.innerLockScreen(true, displayText);
        return this;
    }
    unlockScreen() {
        this.innerLockScreen(false);
        return this;
    }
    private innerLockScreen(value: boolean, displayText?: boolean) {
        value = value !== false;
        displayText = displayText !== false;

        const cssClass = 'lock-screen';
        const noTextCssClassOption = 'no-text';
        const $b = $('body');

        if (value) {
            if (this._screenIsLocked)
                if ($b.hasClass(cssClass)) {
                    if (displayText && $b.hasClass(noTextCssClassOption))
                        $b.removeClass(noTextCssClassOption);
                    else if (!displayText && !$b.hasClass(noTextCssClassOption))
                        $b.addClass(noTextCssClassOption);
                    return this;
                }

            $b.addClass(cssClass);
            if (!displayText)
                $b.addClass(noTextCssClassOption);
            this._screenIsLocked = true;
            return;
        }

        if (!this._screenIsLocked)
            if (!$b.hasClass(cssClass)) {
                if ($b.hasClass(noTextCssClassOption))
                    $b.removeClass(noTextCssClassOption);
                return this;
            }

        $b.removeClass(cssClass).removeClass(noTextCssClassOption);
        this._screenIsLocked = false;
    }
    getCurrentCulture() { return context.culture.name || common.Cultures.fr; }
    getMainNavigation() { return this._mainNavigation; }
    getPooler() { return this._pooler; }
    getMessagesManager() { return this._messagesManager; }
    getNotifications() { return this._notifications || null; }
    getMainLoader() {
        if (!this._mainLoader)
            this._mainLoader = new core.Loader("#MainLoader", "#MainContainer", true, true);
        return this._mainLoader;
    }

    showMainLoader() {
        this.getMainLoader().show();
        return this;
    }

    hideMainLoader() {
        this.getMainLoader().hide();
        return this;
    }

    private setupMainLoader(settings: any) {
        var showLoaderTarget = '.fn-show-loader-on-click';
        var hideLoaderTarget = '.fn-hide-loader-on-click';

        if (settings.showerLoaderTarget)
            showLoaderTarget += ', ' + settings.showLoaderTarget;

        if (settings.hideLoaderTarget)
            hideLoaderTarget += ', ' + settings.hideLoaderTarget;

        $(showLoaderTarget).on('click', () => {
            this.showMainLoader();
        });

        $(hideLoaderTarget).on('click', () => {
            this.hideMainLoader();
        });
    }

    private setupEnvironmentButtonDisplayer() {
        if (!(context as any).env.currentIsLab)
            return;

        const buttonText = {
            show: "Afficher l'environnement",
            hide: "Cacher l'environnement"
        };
        const buttonToolTip = {
            show: "Cliquer pour afficher l'environnement",
            hide: "Cliquer pour cacher l'environnement"
        };
        const stateAttribute = "data-display-env";
        const bypassAttribute = "data-display-env-bypass";
        const storageKey = "pageComponent_displayEnvironment";
        const initialState = (context as any).storage.retrieve(storageKey) === "true";
        const $body = $("#MainBody");
        const $button = $body
            .find("#EnvironmentDisplayerButton")
            .on('click', e => {
                const $thisButton = $(e.currentTarget as any);
                toggle($thisButton);
            });

        toggle($button, initialState, false);

        function toggle($e: JQuery, forceDisplay?: boolean, store?: boolean) {
            const newState = forceDisplay === true || forceDisplay === false ? forceDisplay : !getCurrentState($e);
            $e.html(newState ? buttonText.show : buttonText.hide).attr("title", newState ? buttonToolTip.show : buttonToolTip.hide);
            setBypassDisplay(newState);
            setCurrentState($e, newState, store);
        }

        function getCurrentState($e: JQuery) {
            return $e.attr(stateAttribute) === "true";
        }

        function setCurrentState($e: JQuery, state: boolean, store?: boolean) {
            const value = state ? "true" : "false";
            if (store !== false)
                (context as any).storage.store(storageKey, value);
            return $e.attr(stateAttribute, value);
        }

        function setBypassDisplay(isBypassed: boolean) {
            return $body.attr(bypassAttribute, isBypassed ? "true" : "false");
        }
    }

    drawTreeNodes() {
        if (!context.components.items?.DefaultEdit?.length) {
            console.warn("Aucun composant de type 'DefaultEdit' trouvé pour dessiner l'arbre.");
            return "";
        }
        return (context.components.items.DefaultEdit[0] as DefaultEdit_).drawTreeNodes();
    }
}

export = Page;